import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Form,
  FormFeedback,
  Alert,
  Spinner,
} from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { Link, useNavigate } from "react-router-dom";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast, ToastContainer } from "react-toastify"; // Ensure toast is imported

import logoLight from "../../assets/teaboy/logo-light.png";
import withRouter from "../../Components/Common/withRouter";
import { useAuth } from "../../stores/Auth/Auth";

const Login = (props) => {
  document.title = "Clickorder Admin";

  const { login, isLoading, errorMsg, successMsg, clearMessages } = useAuth();
  const [passwordShow, setPasswordShow] = useState(false);

  const navigate = useNavigate();

  // this is  supper really bad , I regret writing it but this is the only way to handle it !!
  if (
    errorMsg ===
    "Email not verified. Please check your email for the verification link."
  ) {
    navigate("/auth/validate-email-sent");
  }

  useEffect(() => {
    clearMessages();

    return () => clearMessages();
  }, [clearMessages, errorMsg, successMsg]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      login(values, props.router);
    },
  });

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container style={{ display: "flex", flexDirection: "column" }}>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <div className="d-flex align-items-center gap-2">
                        <img src={logoLight} alt="" height="20" />
                      </div>
                    </Link>
                  </div>
                  <p className="mt-3 fs-15 fw-medium">
                    Elevating next level hospitality.
                  </p>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">Welcome Back!</h5>
                      <p className="text-muted">
                        Manage your ClickOrder account and assets
                      </p>
                    </div>

                    <div className="p-2 mt-4">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <div className="mb-3">
                          <Label htmlFor="email" className="form-label">
                            Email
                          </Label>
                          <Input
                            name="email"
                            className="form-control"
                            placeholder="Enter email"
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                            }
                          />
                          {validation.touched.email &&
                            validation.errors.email && (
                              <FormFeedback type="invalid">
                                {validation.errors.email}
                              </FormFeedback>
                            )}
                        </div>

                        <div className="mb-3">
                          <Label
                            className="form-label"
                            htmlFor="password-input"
                          >
                            Password
                          </Label>
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <Input
                              name="password"
                              value={validation.values.password || ""}
                              type={passwordShow ? "text" : "password"}
                              className="form-control pe-5"
                              placeholder="Enter Password"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.password &&
                                validation.errors.password
                              }
                            />
                            {validation.touched.password &&
                              validation.errors.password && (
                                <FormFeedback type="invalid">
                                  {validation.errors.password}
                                </FormFeedback>
                              )}
                            <button
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                              type="button"
                              id="password-addon"
                              onClick={() => setPasswordShow(!passwordShow)}
                            >
                              <i className="ri-eye-fill align-middle"></i>
                            </button>
                          </div>
                        </div>

                        <div className="d-flex justify-content-between">
                          <div className="form-check">
                            <Input
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id="auth-remember-check"
                            />
                            <Label
                              className="form-check-label"
                              htmlFor="auth-remember-check"
                            >
                              Remember me
                            </Label>
                          </div>
                          <Link
                            to="/forgot-password"
                            className="fw-semibold text-primary text-decoration-underline"
                          >
                            Forgot Password?
                          </Link>
                        </div>

                        <div className="mt-4">
                          <button
                            disabled={isLoading}
                            className="btn w-100 text-white font-bold"
                            style={{ background: "#ce9558" }}
                            type="submit"
                          >
                            {isLoading ? (
                              <>
                                <Spinner size="sm" className="me-2" />
                                Loading...
                              </>
                            ) : (
                              "Sign In"
                            )}
                          </button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-4 text-center">
                  <p className="mb-0">
                    Don't have an account?
                    <Link
                      to="/register"
                      className="fw-semibold text-primary text-decoration-underline ms-4"
                    >
                      Sign up
                    </Link>
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
      {/* <ToastContainer autoClose={2000} limit={1} /> */}
    </React.Fragment>
  );
};

export default withRouter(Login);
